import React, { useState, useEffect } from "react"; //, useEffect

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from "../../../actions/api";
import ProtocolFormData from "./ProtocolFormData";
import encryptionService from "../../../services/encryptionService";

const AddProtocol = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "protocol";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState("");

  let params = {
    menukey: "protocol",
    FacilityId: 512,
    TransactionTypeId: "",
    Page: "Protocol",
    TransactionDate: "",
  };
  const { data: invoiceNo } = useQuery([params], api.getInvoiceNo, {
    onSuccess: (data) => {
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData };
      fdata["code"] = data;
      setFormData(fdata);
    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0, //1000 * 60 * 60 * 24,
  });

  const IntervalList = JSON.parse(localStorage.getItem("IntervalList"));

  const [formData, setFormData] = useState({
    code: generatedInvoiceNo,
    RegimenId: "",
    protocolName: "",
    protocolShortName: "",
    protocolType: "None",
    details: [],
  });

  const [ManyTableData, setManyTableData] = useState([]);
  const [errorObject, setErrorObject] = useState({});

  const { id } = useParams();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(api.saveProtocol, {
    onSuccess: (data) => {
      if (data.status == 200) {
        let route = `edit/${data.ProtocolId}`;
        props.history.push(route);

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    data[name] = value;
    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleProductAdd = (NonOrderProductData) => {
    let data = { ...formData };

    data["details"] = NonOrderProductData;
    setFormData(data);

    console.log("Add product in edit page: ", data);
    // setManyTableData(NonOrderProductData)
  };

  const handleReset = () => {
    setFormData({
      code: "",
      RegimenId: "",
      protocolName: "",
      protocolShortName: "",
      protocolType: "None",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["code", "RegimenId", "protocolName"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleSubmit = async (e) => {
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        ManyJsonSave: ManyTableData,
        menukey: "protocol",
        lan: lan,
        UserName: UserName,
      };

      mutate(fDtat);
      //swal("Success!", "", "success");
    }
  };

  const handleDetailChange = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailDropDownChange = (e, rowData) => {
    console.log(
      "Product before update rows when dropdown change in edit page: ",
      rowData
    );
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;

        console.log("IntervalList: ", IntervalList);
        console.log("cur intervalId: ", rowData.intervalId);

        const curInvervalValueObj = IntervalList.filter((intervalRow) => {
          if (rowData.intervalId == intervalRow.id) {
            return intervalRow;
          }
        });
        console.log("curInvervalValueObj: ", curInvervalValueObj);
        console.log("curInvervalValue: ", curInvervalValueObj[0].value);

        let calcQty =
          detail["formulationQty"] *
          detail["dur"] *
          curInvervalValueObj[0].value;
        detail["calc"] = calcQty;
      }
      return detail;
    });

    console.log(
      "Product updated rows when dropdown change in edit page: ",
      details
    );
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailCheck = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, checked } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = checked;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const setUpdatedDetailsGridDataHandler = (rows, curcol) => {
    if (curcol === "formulationQty" || curcol === "dur" || curcol === "packs") {
      let data = { ...formData };
      let ManyTableData = data["details"];

      const updateManyTableData = ManyTableData.map((row) => {
        if (row.id == rows.id) {
          if (curcol === "formulationQty" || curcol === "dur") {
            const curInvervalValueObj = IntervalList.filter((intervalRow) => {
              if (rows.intervalId == intervalRow.id) {
                return intervalRow;
              }
            });

            row.formulationQty = rows.formulationQty;
            row.dur = rows.dur;
            //row.rep = rows.rep;
            let calcQty =
              rows.formulationQty * rows.dur * curInvervalValueObj[0].value;
            row.calc = calcQty;
          } else if (curcol === "packs") {
            let calDispQty = "";
            if (rows.packs > 0) {
              calDispQty = rows.PacksizeName * rows.packs;
            }
            row.productQty = calDispQty;
          }
        }
        return row;
      });
      data["details"] = updateManyTableData;
      console.log("Product updated rows in edit page: ", updateManyTableData);
      setFormData(data);
    }
  };

  const deleteProtocolItems = (data) => {
    let newarray = ManyTableData.filter((element) => element !== data);
    setManyTableData(newarray);
  };

  useEffect(() => {}, [formData]);

  return (
    <>
      <ProtocolFormData
        errorObject={errorObject}
        addProductForm={true}
        formData={formData}
        setFormData={setFormData}
        handleChange={handleChange}
        handleReset={handleReset}
        handleSubmit={handleSubmit}
        ManyTableData={ManyTableData}
        deleteProtocolItems={deleteProtocolItems}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        handleDetailChange={handleDetailChange}
        handleAdd={handleAdd}
        productAdd={handleProductAdd}
        handleDetailDropDownChange={handleDetailDropDownChange}
        handleDetailCheck={handleDetailCheck}
        /* permissionType={props.permissionType} */

        {...props}
      />
    </>
  );
};

export default AddProtocol;
